import { Box, withStyles } from '@material-ui/core';

export const WrapperBox = withStyles(({ palette }) => ({
  root: {
    borderRadius: 10,
    background: palette.common.white,
  },
}))(Box);
